import React, { ReactElement, useEffect } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../../routing/routes';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import PredbeznaInformaciaList from '../../../module/LegislativnyMaterial/PredbeznaInformaciaList';
import useFilterFromUrl
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialList/hooks/useFilterFromUrl';
import externalRoutes from '../../../routing/externalRoutes';
import SuccessMessages from '../../../module/SuccessMessages';
import useHistoryPageContext from '../../../context/BreadcrumbContext/hook/useHistoryPageContext';
import RssLink from '../../../module/PageHeadingWithBackButton/RssLink';

const PredbeznaInformaciaListPage = (): ReactElement => {
  const {
    initialFilter,
    initialFilterLoading,
  } = useFilterFromUrl();

  const { setHistoryPages } = useHistoryPageContext();
  useEffect(() => {
    setHistoryPages([]);
  }, [setHistoryPages]);

  useEffect(() => {
    window.parent.postMessage({
      type: 'iframe-to-parent-set-meta',
      title: 'Predbežné informácie',
      description: 'Prehľad predbežných informácií na portáli '
          + 'Slov-Lex - aktuálne údaje o plánovaných právnych predpisoch SR.',
    }, '*');
  }, []);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.procesy.predbeznaInformacia.list,
          heading: 'Predbežné informácie',
        },
      ]}
      />
      <GlobalErrors />
      <SuccessMessages />
      <PageHeadingWithBackButton
        heading="Predbežné informácie"
        elementNextToHeading={(
          <RssLink to={externalRoutes.rss.legislativnyMaterial.list} />
            )}
      />
      <Loader loading={initialFilterLoading}>
        {initialFilter && !initialFilterLoading && (
          <PredbeznaInformaciaList initialFilter={initialFilter} />
        )}
      </Loader>
    </Layout>
  );
};

export default PredbeznaInformaciaListPage;
